import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Pageable,
  PaymentFormFilterSpec,
  ListPaymentFormFilterSpec,
  WrapperPageableResponse
} from './service-common';
import type { PaymentFormDTO } from '../core/models';

export type WrapperPageableResponsePaymentFormDTO = WrapperPageableResponse<PaymentFormDTO>;

@Injectable({
  providedIn: 'root'
})
export class PaymentFormService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  searchPaymentForms(
    spec: PaymentFormFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponsePaymentFormDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(s => params = params.append('sort', s));
    }
    return this.http.get<WrapperPageableResponsePaymentFormDTO>(`${this.apiUrl}/payment-forms`, { params });
  }

  listPaymentForms(
    spec: ListPaymentFormFilterSpec = {},
    pageable: Pageable = { page: 0, size: 500 }
  ): Observable<WrapperPageableResponsePaymentFormDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(s => params = params.append('sort', s));
    }
    return this.http.get<WrapperPageableResponsePaymentFormDTO>(`${this.apiUrl}/payment-forms/list`, { params });
  }
}
